import { useCallback } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { clearRememberedUsers, getRememberedUsers, setRememberedUsers } from '../rememberedUsers';

const useLogout = (param, Gfunc) => {

  const logout = useCallback(() => {

    // let rememberedUsers = JSON.parse(localStorage.getItem("rememberedUsers") || "[]");
    // get the current user info from localStorage before clearing it
    const rememberedUser = {
      name: localStorage.getItem("name"),
      uid: localStorage.getItem("uid"),
      email: localStorage.getItem("email"),
      profileImage: localStorage.getItem("profileImage"),
      nickname: localStorage.getItem("nickname"),
      // profileImage: localStorage.getItem("profileImage"),
      img : localStorage.getItem("img"),
      nodes: JSON.parse(localStorage.getItem("nodes") || "{}"),
    };

    let rememberedUsers = getRememberedUsers();
    rememberedUsers = rememberedUsers.filter(u => u.uid !== rememberedUser.uid);
    rememberedUsers.unshift(rememberedUser);
    rememberedUsers = rememberedUsers.slice(0, 3); //limit to 3 users

    axios
      .get(`${param.urlService}disconnect.php`, {
        headers: Gfunc.getHeader(),
      })
      .then((response) => {
        if (response.data.jData === true) {
    
          localStorage.clear();
          setRememberedUsers(rememberedUsers);
          window.location = "/";
        }
      })
      .catch((error) => {
        console.error("Logout error:", error);
      });
  }, [param, Gfunc]);

  return logout;
};

export default useLogout;